export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13188.149a3232.jpg";